"use strict";

(function () {
  let recaptchaElementsToInitOnload = [];
  let recaptchaScriptAttached = false;
  let recaptchaResolved = false;
  const recaptchaLanguageCodes = ['ar', 'af', 'am', 'hy', 'az', 'eu', 'bn', 'bg', 'ca', 'zh-HK', 'zh-CN', 'zh-TW', 'hr', 'cs', 'da', 'nl', 'en-GB', 'en', 'et', 'fil', 'fi', 'fr', 'fr-CA', 'gl', 'Value', 'ka', 'de', 'de-AT', 'de-CH', 'el', 'gu', 'iw', 'hi', 'hu', 'is', 'id', 'it', 'ja', 'kn', 'ko', 'lo', 'lv', 'lt', 'ms', 'ml', 'mr', 'mn', 'no', 'fa', 'Value', 'pl', 'pt', 'pt-BR', 'pt-PT', 'ro', 'ru', 'sr', 'si', 'sk', 'sl', 'es', 'es-419', 'sw', 'sv', 'ta', 'te', 'th', 'tr', 'uk', 'ur', 'vi', 'zu'];
  onDOMReady(function () {
    const elements = document.getElementsByClassName('recaptcha__recaptcha');
    if (elements.length) {
      recaptchaScriptAttach();
    }
    for (let i = 0; i < elements.length; i++) {
      recaptchaElementsToInitOnload.push(elements[i]);
    }
  });
  window.km_recaptchaAddElementById = function (id) {
    const element = document.getElementById(id);
    if (window.hasOwnProperty('grecaptcha')) {
      recaptchaInitElement(element);
    } else {
      recaptchaElementsToInitOnload.push(element);
      recaptchaScriptAttach();
    }
  };
  const recaptchaScriptAttach = function () {
    if (!recaptchaScriptAttached) {
      const documentLang = document.documentElement.getAttribute('lang');
      const lang = recaptchaLanguageCodes.includes(documentLang) ? documentLang : 'en';
      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://www.google.com/recaptcha/api.js?onload=km_recaptchaScriptOnloadCallback&render=explicit&hl=' + lang;
      scriptElement.async = true;
      document.head.appendChild(scriptElement);
      recaptchaScriptAttached = true;
    }
  };
  window.km_recaptchaScriptOnloadCallback = function () {
    for (let i = 0; i < recaptchaElementsToInitOnload.length; i++) {
      const element = recaptchaElementsToInitOnload[i];
      recaptchaInitElement(element);
    }
    recaptchaElementsToInitOnload.length = 0;
  };
  const recaptchaInitElement = function (element) {
    window.grecaptcha.ready(function () {
      if (element.hasAttribute('data-recaptcha-init')) {
        return;
      }
      element.setAttribute('data-recaptcha-init', '1');
      window.grecaptcha.render(element);
      const badge = element.getElementsByClassName('grecaptcha-badge')[0];
      badge.style.height = '0';
      badge.style.visibility = 'hidden';
      const form = element.closest('form');
      form.addEventListener('submit', recaptchaFormSubmitListenerFactory(form));
    });
  };
  const recaptchaFormSubmitListenerFactory = function (form) {
    return function (e) {
      // we already have reCaptcha response, or the form is invalid - or submission is prevented for some other, unknown reason
      if (recaptchaResolved || e.defaultPrevented) {
        return;
      }
      e.preventDefault();
      window.grecaptcha.execute().then(function (token) {
        recaptchaResolved = true;

        // reCaptcha token expires after 2 minutes; make it 5 seconds earlier just in case network is slow
        setTimeout(function () {
          recaptchaResolved = false;
        }, (2 * 60 - 5) * 1000);
        const inputs = document.getElementsByClassName('g-recaptcha-response');
        for (let i = 0; i < inputs.length; i++) {
          inputs[i].value = token;
        }
        form.submit();
      });
    };
  };
})();

// jQuery free